export const Chaleco1 = require("./chaleco-1.png")
export const Chaleco2 = require("./chaleco-2.png")
export const Chaleco3 = require("./chaleco-3.png")